import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#packages", label: "Packages" },
  { href: "#booking", label: "Book" },
  { href: "#gallery", label: "Gallery" },
  { href: "#testimonials", label: "Reviews" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`sticky top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FDF9F3]/90 border-b border-[#E9DFCB]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-baseline gap-2">
          <span className="font-serif text-2xl font-bold text-[#3D2E1C] tracking-tight">Overdrive</span>
          <span className="font-hand text-xl text-[#A67F4E]">auto spa</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-[#3D2E1C]/70 hover:text-[#A67F4E] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#booking"
          data-testid="navbar-book-button"
          className="hidden md:inline-flex items-center px-5 py-2.5 bg-[#3D2E1C] text-[#FDF9F3] hover:bg-[#A67F4E] transition-all duration-300 text-sm font-semibold rounded-full"
        >
          Book Now →
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-[#3D2E1C]"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FDF9F3]/98 backdrop-blur-xl border-t border-[#E9DFCB]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className="text-sm font-medium text-[#3D2E1C]/80 hover:text-[#A67F4E]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#booking"
              onClick={() => setOpen(false)}
              data-testid="mobile-book-button"
              className="inline-flex justify-center px-5 py-3 bg-[#3D2E1C] text-[#FDF9F3] text-sm font-semibold rounded-full"
            >
              Book Now →
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
